<script lang="ts">
  import DropdownList from '$shared/atoms/DropdownList/DropdownList.svelte';

  interface Props {
    x?: number;
    y?: number;
    list?: CommonList[];
    onclick?: (item: CommonList) => void;
  }

  let { x = 0, y = 0, list = [], onclick }: Props = $props();
</script>

<div class="comp-context-menu" style="top: {y}px; left: {x}px;">
  <DropdownList {list} {onclick} />
</div>

<style>
  .comp-context-menu {
    position: fixed;
    top: 0;
    left: 0;
    display: block;
    z-index: 999;
  }
</style>
